export const StoreCardSkeleton = () => {
    return <li className={"store-card store-card--skeleton"} />;
};
